import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { List } from '@mui/material';
import SidebarItem from '@shared/SidebarItem/SidebarItem';
import { useTheme } from '../theme';
import { isRouteSelected } from '../Account/utils';
import { concatPassengerNames } from '../utils';
const Sidebar = ({ routes, selectedRoute, userInfo }) => {
    const { Sidebar: css } = useTheme('Sidebar');
    const { t } = useTranslation('Account');
    const title = useMemo(() => !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName) && !!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.lastName)
        ? concatPassengerNames({ lastName: userInfo.lastName, firstName: userInfo.firstName })
        : t('My cabinet'), [userInfo]);
    return (React.createElement(List, { className: css.sidebar, disablePadding: true, classes: {
            root: css.root
        } },
        React.createElement("div", { className: css.title }, title),
        routes.map(route => (React.createElement(SidebarItem, { key: route.title, route: route, isSelected: isRouteSelected(route, selectedRoute) })))));
};
export default Sidebar;
